export function callOnce(el: HTMLElement, event: string, fn: () => void, opts = {}) {
    const onceFn = function () {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
    };

    el.addEventListener(event, onceFn, opts);
    return onceFn;
}